"use client";

import styles from "./HeroSubBannerLp.module.scss";
import Image from "next/image";
import StatsContainer from "../StatsContainerLp/StatsContainerLp";
import cn from "clsx";
import { useEffect, useRef } from "react";
import { pushToDataLayer } from "@/helpers/gtag";
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import { usePathname } from "next/navigation";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";
import useOnScreen from "@/helpers/Onscreen";
import { useCommonData } from "@/context/CommonDataContext";
import { getLandingRegion } from "@/features/landing-program/utils/landingRegion";

const IMG_BASE_URL = process.env.NEXT_PUBLIC_NEW_IMAGE_PATH;
interface SubBannerContentProps {
  associatedPrograms: any;
  Brochure?: {
    data?: {
      attributes?: {
        url?: string;
      };
    };
  };
}

const AffiliatedLogoContent = () => {
    const pathname = usePathname();

    const pathList = ["/master-of-business-administration-online-v1", "master-of-business-administration-online", "/lp-nw/mba-v1", "/lp-nw/mba","/lp-nw/mba-finance-accounting-management", "/lp-nw/mba-digital-marketing-management-online", "lp-nw/mba-human-resource-management"];
    const isMBAPage = pathList.includes(pathname.toLowerCase());
    const qsBadgeText = getLandingRegion(pathname)?.qsBadgeText;

    return (
        <div className={styles.affiliated_logo_content}>
            <div className={styles.ugc_ent}>
                <Image
                    src={IMG_BASE_URL + "_s/gyan_vigyan_a23375b79d.svg"}
                    width={22}
                    height={22}
                    alt="gyan vigyan logo"
                    fetchPriority="low"
                />
                <span className="text-[#1A325D]">UGC Entitled</span>
            </div>
            
           {isMBAPage && <div className={styles.asia_pacific}>
                <div className={styles.img_container}>
                    <Image
                        src={IMG_BASE_URL + "_s/QS_Icon_2c33592d23.svg"}
                        width={22}
                        height={22}
                        alt="qs icon logo"
                        className="h-full flex-1"
                    />
                </div>
                {qsBadgeText ? (
                    <span className="text-[#1A325D]">{qsBadgeText}</span>
                ) : (
                    <span className="text-[#1A325D] capitalize">top 10 in asia pacific</span>
                )}
                <span className={styles.tooltip}>QS Ranked Online MBA, 2024</span>
            </div>
            }
        </div>
    )
};


const CourseName = ({ ProgramHeading }) => {
  return (
    <div className={styles.course_name} dangerouslySetInnerHTML={{ __html: ProgramHeading }} />
  );
};

const Duration = ({ duration }) => {
  return (
    <div className={styles.duration}>
      <Image
        src={IMG_BASE_URL + "_s/duration_watch_4c87a93418.svg"}
        width={22}
        height={22}
        alt="duration logo"
      />
      <span className="lining-nums">{duration}</span>
    </div>
  );
};

const BrouchreDownloadContainer = ({
  associatedPrograms,
  Brochure = {},
}: SubBannerContentProps)=> {
  const modalDispatch = useModalDispatch();
const BrochureLink=Brochure?.data?.attributes?.url
  const downloadBrochurePopup = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalMba,
        modalData: {
          rfiCase: "DOWNLOAD_BROCHURE_CASE_THANK_YOU",
          attachmentURL: BrochureLink,
          associatedPrograms,
          modalVariant: "downloadBrochure",
          isLambdaAPI:true
        },
      },
    });

    setTimeout(()=> {
      updateStateSession({ leadStartingCta: "Download Brochure", parentSection: "hero_banner" });
      pushToDataLayer({
            event: "lead_initiate",
            cta_text: "Download Brochure",
            section_name: "hero_banner",
            page_type: getGlobalStateValue("pageType"),
            page_url_custom: location.href,
          });

    },2000)

  };
  
  return (
    <div className={styles.brochure_share_btn_container}>
      <button onClick={downloadBrochurePopup} className={styles.download_br}>
        download brochure
        <Image
          src={IMG_BASE_URL + "_s/down_arrow_db_2b837a8c53.svg"}
          width={26}
          height={26}
          alt="download brochure logo"
        />
      </button>
    </div>
  );
};

const GlobalCred = ({ BannerImageTemplete }) => {

    const ref = useRef(null)
    const onScreen = useOnScreen(ref);
    const { device } = useCommonData();
    const isDweb = device === "desktop";

    useEffect(()=>{

      const callIcon = document.getElementById('call-icon');
      const whatsapp = document.getElementById('whatts-app-journey');
      const chatButtonIcon = document.getElementById('chat-launcher-btn');
      const enrollNowRef = document.getElementById("enroll-now-cta");

      // DWeb: sticky side-tray icons (Call / WhatsApp / CMS icons) stay visible
      // over the hero. getElementById only reached Call + the first tray link,
      // so CMS-added icons never hid — keep them all consistent. MWeb unchanged.
      if (callIcon && !isDweb) {
        if (onScreen) {
          callIcon.style.display = "none";
        } else {
          callIcon.style.display = "block";
        }
      }
  
      if (whatsapp && !isDweb) {
        if (onScreen) {
          whatsapp.style.display = "none";
        } else {
          whatsapp.style.display = "block";
        }
      }
  
      if (chatButtonIcon) {
        if (onScreen) {
          chatButtonIcon.style.display = "none";
        } else {
          chatButtonIcon.style.display = "block";
        }
      }
  
      if(enrollNowRef){
        if (onScreen) {
          enrollNowRef.style.display = "none";
        } else {
          enrollNowRef.style.display = "block";
        }
      }

    },[onScreen, isDweb])

  return (
    <div className={styles.global_accred} ref={ref}>
      <span className={styles.global_text}>{BannerImageTemplete?.GlobalAccredationText}</span>
      {BannerImageTemplete?.GlobalAccredationImageOne?.data && <Image src={BannerImageTemplete?.GlobalAccredationImageOne.data.attributes.url} width={80} height={25} alt="WASC" />}
      {BannerImageTemplete?.GlobalAccredationImageTwo?.data && <Image
        src={BannerImageTemplete?.GlobalAccredationImageTwo.data.attributes.url}
        width={60}
        height={25}
        alt="Times Higher"
      />}
      {BannerImageTemplete?.GlobalAccredationImageThree?.data && <Image src={BannerImageTemplete?.GlobalAccredationImageThree.data.attributes.url} width={75} height={25} alt="QAA" />}
      {BannerImageTemplete?.GlobalAccredationImageFour?.data && <Image src={BannerImageTemplete?.GlobalAccredationImageFour.data.attributes.url} width={25} height={25} alt="WES" />}
    </div>
  );
};

const SubBannerContentLp = ({ isMobile = false, BannerImageTemplete, associatedPrograms,Brochure={} }) => {
  return (
    <div className={styles.content_container}>
      <AffiliatedLogoContent />
      <CourseName ProgramHeading={BannerImageTemplete?.ProgramHeading}/>
      <Duration duration={BannerImageTemplete?.Duration} />
      <BrouchreDownloadContainer Brochure={Brochure} associatedPrograms={associatedPrograms} />
      <StatsContainer BannerImageTemplete={BannerImageTemplete} isStatsDisplay={!isMobile} />
      <GlobalCred BannerImageTemplete={BannerImageTemplete} />
    </div>
  );
};

export default SubBannerContentLp;
